import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * La conciliación bancaria, dentro del grupo `_contabilidad`.
 *
 * Las cuatro funciones de la feature 22 exigen `contador` o `administrador`, y quien concilia el
 * extracto es la contadora. No va en `_direccion`, que es del administrador solo: ahí la contadora
 * no entraría y es la que hace este trabajo.
 */
export const rutaConciliacion = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/banco/conciliacion',
  component: lazyRouteComponent(() => import('./conciliacion-pantalla.js'), 'RutaConciliacion'),
});
